import React from 'react';
import { Create, SimpleForm, TextInput } from 'react-admin';

export const QuoteCreate = () => (
  <Create title="Create quote" redirect="list">
    <SimpleForm>
      <TextInput source="quote_text" label="Quote Text" required multiline rows={4} />
      <TextInput source="author_name" label="Author" required />
    </SimpleForm>
  </Create>
);

